import { CrawlMonitorApi } from '@liks/lac-svc-api/esm/apis/CrawlMonitorApi';
import type {
  CrawlJobMonitorDTO,
  LacCrawlJobListItem,
  LacListCrawlJobsOptions,
} from '../types/lac';
import { lacApiConfiguration } from './lacApi';

export const LAC_CRAWL_JOBS_PAGE_SIZE = 20;

export type {
  LacCrawlJobListItem,
  LacListCrawlJobsOptions,
} from '../types/lac';

function hasCrawlJobId(job: CrawlJobMonitorDTO): job is LacCrawlJobListItem {
  return typeof job.crawlJobId === 'string' && job.crawlJobId.trim() !== '';
}

class LacCrawlMonitorService {
  private readonly crawlMonitorApi = new CrawlMonitorApi(lacApiConfiguration);

  /**
   * One page of cross-tenant crawl jobs.
   */
  async listCrawlJobs(
    options: LacListCrawlJobsOptions = {},
  ): Promise<LacCrawlJobListItem[]> {
    const page =
      await this.crawlMonitorApi.deLiksCrawlmonitorBoundaryCrawlMonitorResourceListCrawlJobs(
        {
          offset: options.offset ?? 0,
          limit: options.limit ?? LAC_CRAWL_JOBS_PAGE_SIZE,
          startUrl: options.startUrl,
          tenantName: options.tenantName,
          fromDate: options.fromDate,
          toDate: options.toDate,
          status: options.status,
        },
      );

    return page.filter(hasCrawlJobId);
  }
}

export const lacCrawlMonitorService = new LacCrawlMonitorService();
